import { render } from "./ChipsAutocomplete.vue?vue&type=template&id=3dad6974&scoped=true"
import script from "./ChipsAutocomplete.vue?vue&type=script&lang=js"
export * from "./ChipsAutocomplete.vue?vue&type=script&lang=js"

import "./ChipsAutocomplete.vue?vue&type=style&index=0&id=3dad6974&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dad6974"]])

export default __exports__